import React, { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import "./CostOfWorksReports.css";

const CostOfWorksReports = () => {
  const { user } = useAuth();
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchReportData = async () => {
      setLoading(true);
      setError("");
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(
          `${
            process.env.REACT_APP_API_URL || "http://localhost:3001"
          }/api/cost-of-works/reports`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch report data");
        }

        const data = await response.json();
        setReportData(data);
      } catch (err) {
        setError(err.message || "Failed to load report data");
      } finally {
        setLoading(false);
      }
    };

    fetchReportData();
  }, []);

  if (loading) {
    return (
      <div className="cost-of-works-reports-layout">
        <div className="container">
          <div className="loading">Loading report data...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="cost-of-works-reports-layout">
        <div className="container">
          <div className="error">Error: {error}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="cost-of-works-reports-layout">
      <div className="container">
        <div className="reports-header">
          <h1>Cost of Works Reports</h1>
          {reportData?.client && <p>Client: {reportData.client.name}</p>}
        </div>

        {reportData?.summary && (
          <div className="row">
            <div className="col-md-3">
              <div className="report-card">
                <h3>Total Cost</h3>
                <div className="report-amount">
                  £{reportData.summary.totalCost}
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="report-card">
                <h3>Average Cost</h3>
                <div className="report-amount">
                  £{reportData.summary.averageCost}
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="report-card">
                <h3>Total Tickets</h3>
                <div className="report-amount">
                  {reportData.summary.totalTickets}
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="report-card">
                <h3>Properties</h3>
                <div className="report-amount">
                  {reportData.summary.propertiesCount}
                </div>
              </div>
            </div>
          </div>
        )}

        {reportData?.propertyCosts &&
          Object.keys(reportData.propertyCosts).length > 0 && (
            <div className="row">
              <div className="col-md-12">
                <div className="property-costs-container">
                  <h3>Costs by Property</h3>
                  {Object.entries(reportData.propertyCosts).map(
                    ([propertyId, propertyData]) => (
                      <div key={propertyId} className="property-cost-item">
                        <h4>{propertyData.propertyName}</h4>
                        <div className="property-summary">
                          <span className="property-total">
                            Total: £{propertyData.totalCost}
                          </span>
                          <span className="property-tickets">
                            Tickets: {propertyData.ticketsCount}
                          </span>
                        </div>
                        {propertyData.tickets &&
                          propertyData.tickets.length > 0 && (
                            <table className="table table-sm">
                              <thead>
                                <tr>
                                  <th>Ticket ID</th>
                                  <th>Title</th>
                                  <th>Cost</th>
                                  <th>Status</th>
                                  <th>Created</th>
                                </tr>
                              </thead>
                              <tbody>
                                {propertyData.tickets.map((ticket) => (
                                  <tr key={ticket.id}>
                                    <td>{ticket.id}</td>
                                    <td>{ticket.title}</td>
                                    <td>£{ticket.cost_of_works}</td>
                                    <td>{ticket.status}</td>
                                    <td>
                                      {new Date(
                                        ticket.created_at
                                      ).toLocaleDateString()}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          )}
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          )}

        {reportData?.monthlyBreakdown && (
          <div className="row">
            <div className="col-md-12">
              <div className="monthly-breakdown-container">
                <h3>Monthly Breakdown</h3>
                <div className="monthly-chart">
                  {Object.entries(reportData.monthlyBreakdown).map(
                    ([month, data]) => (
                      <div key={month} className="month-item">
                        <div className="month-label">{month}</div>
                        <div className="month-cost">£{data.cost}</div>
                        <div className="month-tickets">
                          {data.tickets} tickets
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {(!reportData?.propertyCosts ||
          Object.keys(reportData.propertyCosts).length === 0) && (
          <div className="row">
            <div className="col-md-12">
              <div className="no-data">
                <p>No report data available.</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CostOfWorksReports;
